import React from "react";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-16 bg-[#0A2540] text-amber-50/90 toran-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-6 md:grid-cols-3">
        <div>
          <h4 className="font-serif text-xl text-[#D4AF37]">101 {t("club_name") === "लायंस क्लब जयपुर हवामहल" ? "कन्या विवाह" : "Kanya Vivah"}</h4>
          <p className="text-sm mt-2 text-amber-50/70">{t("club_name")}</p>
          <p className="text-sm mt-1 text-amber-50/70">{t("event_on")} · Jaipur</p>
        </div>
        <div className="text-sm text-amber-50/80">
          <a href="/#about" className="block py-1 hover:text-[#D4AF37]">{t("nav_about")}</a>
          <a href="/#process" className="block py-1 hover:text-[#D4AF37]">{t("nav_process")}</a>
          <a href="/#eligibility" className="block py-1 hover:text-[#D4AF37]">{t("nav_eligibility")}</a>
        </div>
        <div className="text-sm text-amber-50/70">
          <p>{t("privacy_title")}</p>
          <p className="mt-2 text-xs leading-relaxed">
            {t("club_name")} · © 2026–2027. Applicants' personal data is never published without separate consent.
          </p>
        </div>
      </div>
    </footer>
  );
}
